import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { AuthStruct, Host, User } from '@/services/api' // clearing pinia stores:

// clearing pinia stores:
// https://github.com/vuejs/pinia/discussions/911

export const useUserStore = defineStore(
  'user',
  () => {
    const account = ref<User>()
    const auth = ref<AuthStruct>()
    const lastHostId = ref<number>(0)

    // User information
    const isLoggedin = computed(() => !!account.value)
    const isAdminUser = computed(() => !!account.value && false)

    function updateUser(userData?: User | null) {
      if (userData) {
        account.value = userData
      } else {
        // api.setSecurityData(null)
        account.value = undefined
      }
    }

    function email() {
      return account.value?.email
    }

    /**
     * Get the account ID.
     *
     * @returns {string|undefined} The ID of the account. Returns undefined if account value is null or undefined.
     */
    function accountId() {
      return account.value?.id
    }

    function fullname() {
      return account.value?.name
    }

    function setHostId(hostId: number) {
      lastHostId.value = hostId
    }

    function hostId() {
      if (!lastHostId.value) {
        // get the first host in our list if we're logged in
        lastHostId.value = (account.value && account.value?.profile?.hosts[0].id) ?? 0
      }
      return Number(lastHostId.value)
    }

    // authorization information
    function triggerRefreshCalc(): boolean {
      const now = Date.now()

      const expiryTime = auth.value?.expiry_ts ?? 0
      const timeLeft = expiryTime - now

      // TCROPLEY DEBUG
      // console.log(['in triggerRefreshCalc', auth.value, now, expiryTime, timeLeft])

      return timeLeft < 60000 // Refresh if token expires in less than 1 minute
    }

    function getAccessToken() {
      return auth.value?.access_token
    }

    function updateAuth(authData?: AuthStruct | null) {
      if (authData) {
        const now = Date.now()

        console.log(['now', now, 'authTTL', authData?.expires_in, 'authData', authData])

        authData.expiry_ts = Number(now) + Number(authData?.expires_in) * 1000

        auth.value = authData
      } else {
        // api.setSecurityData(null)
        auth.value = undefined
      }
    }

    function logout() {
      auth.value = undefined
      account.value = undefined
    }

    function updateHostInformation(updatedHostInfo: Host) {
      const hosts = account.value?.profile?.hosts ?? []

      let hIdx = hosts.findIndex((item) => {
        return item.id === updatedHostInfo.id
      })
      hIdx = hIdx > 0 ? hIdx : 0

      if (account.value?.profile) {
        account.value.profile.hosts[hIdx] = updatedHostInfo
      }
    }

    return {
      account,
      email,
      fullname,
      accountId,
      isLoggedin,
      isAdminUser,
      updateUser,

      auth,
      logout,
      updateAuth,
      getAccessToken,
      triggerRefreshCalc,
      updateHostInformation,

      setHostId,
      hostId
    }
  },
  {
    persist: true
  }
)
